import { mapActions, mapState, mapGetters } from "vuex";
import checkPermission from "../../src/service/checkPermission.js";
export default {
  data() {
    return {
      permission: {
        setting: 100, //设置
        companyManage: 200, //公司管理
        basesetting: 500, //基地设置
        pondSetting: 501, //塘口设置
        cycleBreed: 502, //养殖品种设置
        plantSpecies: 502, //种植品种设置
        companySetting: 503, //公司设置
        peopleManage: 201, //人员管理
        purchaseUnit: 202, //购销单位
        materialSetting: 203, //物资设置
        smartDevice: 101, //智能设备
        purchaseMagage: 102, //购销管理
        fishPurchase: 214, //渔苗采购
        fishSales: 215, //成鱼出售
        materialPurchase: 216, //物资采购
        expenseManage: 103, //费用管理
        expenseRecord: 220, //费用记录
        expenseSetting: 221, //费用设置
        costOriginValue: 218, //资产原值
        assetsCalculation: 219, //资产计提
        productionManage: 104, //生产管理
        productPlan: 225, //生产计划
        cultureCycle: 226, //养殖周期
        loss: 227, //损耗管理
        turnPond: 228, //转塘管理
        proofing: 229, //打样管理
        feeding: 235, //投喂管理
        prevention: 236, //防疫防治
        waterParameters: 230, //水质参数
        waterParametersInput: 515, //水质参数录入
        waterParametersLine: 516, //水质参数曲线图
        bigData: 105, //企业大数据平台
        dataAnalyze: 106, //数据分析
        productionReport: 243, //生产报表
        storagePondReport:250,//预估存塘报表
        outPondReport: 244, //出塘报表
        goodsLossReport: 246, //物资耗用报表
        lossReport: 245, //损失报表
        stockReport: 247, //库存报表
        qualityTracingList: 107, //质量追溯
        deviceManege: 208, //设备管理
        alarmManage: 212
      },
      word: ""
    };
  },
  watch: {
    // 监听isQlwVersion
    whetherQlw(val) {
      this.judgeIsQlw();
    }
  },
  computed: {
    ...mapState(["loginUser", "inQlw", "companyList"]),
    getRoute() {
      return this.$route.path;
    },
    sidebar() {
      return this.leftList;
    },
    // 获取 是否为企联网
    whetherQlw() {
      return this.companyList.isQlwVersion;
    }
  },
  mounted() {
    // console.log("mixin", this.companyList, this.loginUser);
    this.judgeIsQlw();
  },
  methods: {
    getPermissionName(routeName) {
      switch (routeName) {
        case "/setting/companyManagement/baseSetting":
          this.activeName = "basesetting";
          break;
        case "/setting/companyManagement/pondSetting":
          this.activeName = "pondSetting";
          break;
        case "/setting/companyManagement/cultureBreed":
          this.activeName = "cycleBreed";
          break;
        case "/setting/companyManagement/companySetting":
          this.activeName = "companySetting";
          break;
        case "/setting/personManagement":
          this.activeName = "peopleManage";
          break;
        case "/setting/purchaseUnit":
          this.activeName = "purchaseUnit";
          break;
        case "/setting/materialSetting":
          this.activeName = "materialSetting";
          break;
        case "/buyingAndSelling/fryPurchase":
          this.activeName = "fishPurchase";
          break;
        case "/buyingAndSelling/fishSales":
          this.activeName = "fishSales";
          break;
        case "/buyingAndSelling/materialPurchase":
          this.activeName = "materialPurchase";
          break;
        case "/expense/ExpenseRecord":
          this.activeName = "expenseRecord";
          break;
        case "/expense/expenseSetting/detail":
          this.activeName = "expenseSetting";
          break;
        case "/expense/expenseSetting":
          this.activeName = "expenseSetting";
          break;
        case "/productionControl/productionPlan":
          this.activeName = "productPlan";
          break;
        case "/productionControl/cultureCycle":
          this.activeName = "cultureCycle";
          break;
        case "/productionControl/lossManagement":
          this.activeName = "loss";
          break;
        case "/productionControl/turnPondManagement":
          this.activeName = "turnPond";
          break;
        case "/productionControl/proofingManagement":
          this.activeName = "proofing";
          break;
        case "/productionControl/feedingManagement":
          this.activeName = "feeding";
          break;
        case "/productionControl/preventionManagement":
          this.activeName = "prevention";
          break;
        case "/productionControl/waterQualityParameters/parameterInput":
          this.activeName = "waterParametersInput";
          break;
      }
    },
    // 权限判断
    judgeIsQlw() {
      this.getPermissionName(this.$route.path);
      if (
        this.companyList.isQlwVersion == false ||
        this.companyList.isQlwVersion == null
      ) {
        let permission = this.loginUser.permissions.find(item => {
          return item.permissionId == this.permission[this.activeName];
        });
        if (permission) {
          this.edit = !permission.isReadOnly;
        }
      } else if (this.companyList.isQlwVersion == true) {
        checkPermission.checkEdit(this.$route).then(data => {
          this.edit = data;
        });
      }
    },
    // 判断是否有sessionstorage
    judgeSession(keyword) {
      let word = sessionStorage.getItem(keyword);
      if (word) {
        this.word = word;
      } else {
        this.word = "";
      }
    }
  }
};
